import iconDirective from "./icon-directive";
import iconTextDirective from "./icon-text-directive";


export {iconDirective, iconTextDirective};
